export default __webpack_public_path__ + "static/media/McGill.e08f17cd.png";